import { Injectable, Injector, NgZone, inject } from '@angular/core';
import { DiplomaCert, UserProfile } from '@app/core/models';
import { AuthSessionService } from '@app/core/services/auth-session/auth-session.service';
import { ModalManagerInterface } from '@app/core/services/modal-manager';
import { ModalServiceModel } from '@app/core/services/modal-manager/modal-service.model';
import { StorageDocumentsService } from '@app/core/services/storage-documents/storage-documents.service';
import { environment } from '@env/environment';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { DrupalConstants, ViewService } from '@makiwin/ngx-drupal8-rest';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DiplomaComponent } from './diploma.component';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DiplomaService extends ModalServiceModel {
  currentUser?: UserProfile;
  viewService = inject(ViewService);
  socialSharing = inject(SocialSharing);
  zone = inject(NgZone);
  cert?: DiplomaCert;
  expires?: string;
  protected component = DiplomaComponent;
  protected options: NgbModalOptions = {
    size: 'lg',
    fullscreen: true,
    windowClass: 'diploma-window opacity-0',
    backdrop: false,
  };

  constructor(private injector: Injector) {
    super();
  }

  fetch(categoryTid: number) {
    return this.viewService.get('/api/v1/my-diploma.json', { args: [categoryTid] }).pipe(
      tap((data: DiplomaCert[]) => {
        this.cert = data[0];
        if (!this.cert) {
          return;
        }
      })
    );
  }

  open(modalManager: ModalManagerInterface) {
    this.currentUser = this.injector.get(AuthSessionService).currentUserProfile;
    // get the expiration date of the last active license
    this.viewService.get('/api/v1/api_my_active_license.json').subscribe({
      next: (data: { id: number; expires: string }[]) => {
        this.expires = data[0]?.expires;
        this.share();
      },
    });
    return super.open(modalManager);
  }

  share(): void {
    const container = document.getElementById('diploma-container');
    if (!container) {
      return;
    }
    import('html2canvas').then((html2canvas) => {
      // init html2canvas
      setTimeout(() => {
        html2canvas
          .default(container, {
            useCORS: true,
            scale: 0.8,
          })
          .then((canvas) => {
            this.modalService.dismissAll();
            const authService = this.injector.get(AuthSessionService);
            let url: any;
            if (environment.needD7) {
              url = `https://www.ikointl.com/member-public-detail?uid=${authService.currentUserProfile?.uid}`;
            } else {
              url = `https://next.ikointl.com/members/${authService.currentUserProfile?.name}`;
            }

            const imageBase64 = canvas.toDataURL('image/png');
            this.socialSharing
              .share(
                `${DrupalConstants.Connection.current_user.name} ${this.cert?.training_level} IKO Diploma`,
                `Check my profile at www.ikointl.com`,
                imageBase64,
                url
              )
              .finally(() =>
                this.zone.run(() => {
                  // browser download in case if filesharing was not available
                  const storageDocumentsService = this.injector.get(StorageDocumentsService);
                  canvas.toBlob((blob) => {
                    storageDocumentsService.downloadBrowserFromLink(
                      window.URL?.createObjectURL(blob as Blob),
                      `${this.cert?.training_level}_diploma.png`
                    );
                  });
                })
              );
          });
      });
    });
  }
}
